<template>
  <div class="comment-type-select">
    <v-btn-toggle
      v-model="toggle"
      rounded
    >
      <v-btn
        fab
        x-large
        @click="setCommentType(`home`)"
      >
        <v-avatar>
          <img
            src="https://static.arcgis.com/images/Symbols/PeoplePlaces/Housing.png"
            alt="Where you live"
          >
        </v-avatar>
      </v-btn>
      <v-btn
        fab
        x-large
        @click="setCommentType(`work`)"
      >
        <v-avatar>
          <img
            src="https://static.arcgis.com/images/Symbols/PeoplePlaces/Office.png"
            alt="Where you work or go to school"
          >
        </v-avatar>
      </v-btn>
      <v-btn
        fab
        x-large
        @click="setCommentType(`meet`)"
      >
        <v-avatar>
          <img
            src="https://static.arcgis.com/images/Symbols/PeoplePlaces/Crowd.png"
            alt="Where you meet"
          >
        </v-avatar>
      </v-btn>
      <v-btn
        fab
        x-large
        @click="setCommentType(`play`)"
      >
        <v-avatar>
          <img
            src="https://static.arcgis.com/images/Symbols/PeoplePlaces/Sports.png"
            alt="Where you play (shopping, recreation, entertainment"
          >
        </v-avatar>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "CommentTypeSelect",
  data() {
    return {
      toggle: undefined
    };
  },
  methods: {
    ...mapActions({
      setCommentType: "response/setCommentType"
    })
  }
};
</script>

<style scoped>
.comment-type-select {
  padding: 2%;
}
</style>
